export default "__VITE_ASSET__DdkV9v82__"